var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { Checkbox, FormControlLabel, Grid, ListItem, Typography } from "@mui/material";
import { t } from "i18next";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { Get } from "../../../../api/api";
import { DeclinedJobReasonListUrl, getDeclinedStandardJobs, getSelecteDeclinedStandardJobs, RepairTypeList, upsertPreviousAdditionalJobsAppointmentnURL, upsertPreviousAdditionalJobsEstimateURL, upsertPreviousAdditionalJobsInspectionURL } from "../../../../api/url";
import { ArrowDownIcon, ArrowUPIcon, BlueDropdownIcon, BlueUpIcon } from "../../../../assets/images";
import { MuiStack } from "../../../../components";
import { MuiLoaderButton } from "../../../../components/atoms/loaderButton";
import SkeletonLoader from "../../../../components/atoms/sketeton";
import { EParentModuleName, ESystemName, LOCAL_STORAGE_KEYS } from "../../../../constants";
import { showLoader, showNotification } from "../../../../redux/commonSlice";
import { createAPI, getByIdAPI, getListAPI } from "../../../../redux/crudSlice";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { gray } from "../../../../theme/palette";
import { getLocalStorageItem } from "../../../../utils/storageHelper";
import useAnalyticsEventTracker from "../../../../utils/useAnalyticsEventTracker";
var DeclinedStandardJobs = function (props) {
    var _standardJobs$filter;
    var trackButtonClick = useAnalyticsEventTracker("DeclinedStandardJobs");
    var parentModuleName = props.parentModuleName, jobCount = props.jobCount, currentJobCardData = props.currentJobCardData, jobCardID = props.jobCardID, showGroupItems = props.showGroupItems, disabledPreviousDeclined = props.disabledPreviousDeclined, getSavedStandaredJobUrl = props.getSavedStandaredJobUrl;
    var _a = useParams(), estimateId = _a.estimateId, appointmentId = _a.appointmentId, inspectionId = _a.inspectionId;
    var _b = useState(false), isOpenSection = _b[0], setIsOpenSection = _b[1];
    var _c = useState([]), standardJobs = _c[0], setStandardJobs = _c[1];
    var _d = useState([]), rejectReasonRemarkList = _d[0], setRejectReasonRemarkList = _d[1];
    var _e = useState([]), serviceTypeList = _e[0], setServiceTypeList = _e[1];
    var _f = useState([]), currentlySavedStandardJobs = _f[0], setCurrentlySavedStandardJobs = _f[1];
    var loader = useAppSelector(function (state) { return state.common.isLoader; });
    var _g = useState(true), disableSaveBtn = _g[0], setDisableSaveBtn = _g[1];
    var _h = useState(true), skelaton = _h[0], setSkelaton = _h[1];
    var dispatch = useAppDispatch();
    var savedStandardJobs = useAppSelector(function (state) { return state === null || state === void 0 ? void 0 : state.crud; }).savedStandardJobs;
    var selectedBranch = getLocalStorageItem(LOCAL_STORAGE_KEYS.SELECTED_BRANCH);
    useEffect(function () {
        if (jobCardID) {
            setIsOpenSection(false);
        }
    }, [jobCardID]);
    useEffect(function () {
        getRejectRemarkList();
        getServiceTypeList();
    }, []);
    useEffect(function () {
        if (jobCardID !== "" && jobCardID !== undefined) {
            getStandardJobs();
        }
    }, [jobCardID]);
    var getStandardJobs = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _response$payload, response, _response$payload2;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setSkelaton(true);
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "getDeclineStandardJobs",
                            url: getDeclinedStandardJobs,
                            request: {
                                ParentId: jobCardID,
                                Entity: parentModuleName === EParentModuleName.ServiceEstimate ? ESystemName.Estimate : parentModuleName
                            }
                        }))];
                case 1:
                    response = _a.sent();
                    if (!((response === null || response === void 0 || (_response$payload = response.payload) === null || _response$payload === void 0 || (_response$payload = _response$payload.value) === null || _response$payload === void 0 ? void 0 : _response$payload.statusCode) === 200)) return [3 /*break*/, 3];
                    setStandardJobs(response === null || response === void 0 || (_response$payload2 = response.payload) === null || _response$payload2 === void 0 || (_response$payload2 = _response$payload2.value) === null || _response$payload2 === void 0 ? void 0 : _response$payload2.data);
                    return [4 /*yield*/, getSavedStandardJobs()];
                case 2:
                    _a.sent();
                    _a.label = 3;
                case 3:
                    setSkelaton(false);
                    return [2 /*return*/];
            }
        });
    }); };
    var getSavedStandardJobs = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _result$payload, _result$payload2, _currentJobCardData$d, _response, _response2, requestBody, result, _result$payload$data$, _result$payload3, request, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    requestBody = {};
                    if (parentModuleName === EParentModuleName.ServiceEstimate) {
                        requestBody = {
                            EstimateId: estimateId
                        };
                    }
                    if (parentModuleName === EParentModuleName.Appointment) {
                        requestBody = {
                            AppointmentId: appointmentId
                        };
                    }
                    if (parentModuleName === EParentModuleName.Inspection) {
                        requestBody = {
                            InspectionId: inspectionId
                        };
                    }
                    return [4 /*yield*/, dispatch(getByIdAPI({
                            key: '',
                            url: getSavedStandaredJobUrl,
                            request: requestBody
                        }))];
                case 1:
                    result = _a.sent();
                    if (result !== null && result !== void 0 && (_result$payload = result.payload) !== null && _result$payload !== void 0 && _result$payload.success && (result === null || result === void 0 || (_result$payload2 = result.payload) === null || _result$payload2 === void 0 ? void 0 : _result$payload2.statusCode) == 200) {
                        // setStandardJobs(response?.payload?.data)
                        setCurrentlySavedStandardJobs((_result$payload$data$ = result === null || result === void 0 || (_result$payload3 = result.payload) === null || _result$payload3 === void 0 || (_result$payload3 = _result$payload3.data) === null || _result$payload3 === void 0 ? void 0 : _result$payload3.StandardJob) !== null && _result$payload$data$ !== void 0 ? _result$payload$data$ : []);
                    }
                    request = {
                        PreJobCardDocumentId: inspectionId || estimateId || appointmentId,
                        "JobSource": "PreviousDeclined",
                        "ServiceDetailType": 2,
                        VinNo: currentJobCardData === null || currentJobCardData === void 0 || (_currentJobCardData$d = currentJobCardData.data) === null || _currentJobCardData$d === void 0 ? void 0 : _currentJobCardData$d.VinNo,
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId
                    };
                    response = {};
                    if (!(parentModuleName === EParentModuleName.ServiceEstimate)) return [3 /*break*/, 3];
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "savedStandardJobs",
                            url: getSelecteDeclinedStandardJobs,
                            request: request
                        }))];
                case 2:
                    response = _a.sent();
                    _a.label = 3;
                case 3:
                    if (!(parentModuleName === EParentModuleName.Appointment)) return [3 /*break*/, 5];
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "savedStandardJobs",
                            url: getSelecteDeclinedStandardJobs,
                            request: request
                        }))];
                case 4:
                    response = _a.sent();
                    _a.label = 5;
                case 5:
                    if (!(parentModuleName === EParentModuleName.Inspection)) return [3 /*break*/, 7];
                    return [4 /*yield*/, dispatch(createAPI({
                            key: "savedStandardJobs",
                            url: getSelecteDeclinedStandardJobs,
                            request: request
                        }))];
                case 6:
                    response = _a.sent();
                    _a.label = 7;
                case 7:
                    if ((_response = response) !== null && _response !== void 0 && (_response = _response.payload) !== null && _response !== void 0 && _response.success && ((_response2 = response) === null || _response2 === void 0 || (_response2 = _response2.payload) === null || _response2 === void 0 ? void 0 : _response2.statusCode) == 200) {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                    }
                    else {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getRejectRemarkList = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) { return __awaiter(void 0, void 0, void 0, function () {
                    return __generator(this, function (_a) {
                        Get(DeclinedJobReasonListUrl).then(function (response) {
                            if (response.success && response.data) {
                                setRejectReasonRemarkList(response.data);
                            }
                            resolve(response);
                        }).catch(function (getRejectRemarkListError) {
                            reject(getRejectRemarkListError);
                        });
                        return [2 /*return*/];
                    });
                }); })];
        });
    }); };
    var updateData = function (item, type) {
        var _data = standardJobs === null || standardJobs === void 0 ? void 0 : standardJobs.map(function (i, index) {
            if ((item === null || item === void 0 ? void 0 : item.StandardServiceId) === (i === null || i === void 0 ? void 0 : i.StandardServiceId)) {
                if (type === "reasonItem") {
                    var _i = _objectSpread(_objectSpread({}, i), {}, {
                        isResonOpen: !(i !== null && i !== void 0 && i.isResonOpen)
                    });
                    return _i;
                }
                if (type === "groupItem") {
                    var _i = _objectSpread(_objectSpread({}, i), {}, {
                        isOpen: !(i !== null && i !== void 0 && i.isOpen)
                    });
                    return _i;
                }
            }
            else {
                return i;
            }
        });
        setStandardJobs(_data);
    };
    var onGroupChange = function (e, item) {
        var _data = standardJobs === null || standardJobs === void 0 ? void 0 : standardJobs.map(function (i, index) {
            if ((item === null || item === void 0 ? void 0 : item.StandardServiceId) === (i === null || i === void 0 ? void 0 : i.StandardServiceId)) {
                var _i = _objectSpread(_objectSpread({}, i), {}, {
                    isSelected: !(i !== null && i !== void 0 && i.isSelected)
                });
                return _i;
            }
            else {
                return i;
            }
        });
        setStandardJobs(_data);
        setDisableSaveBtn(false);
    };
    var getReason = function (option) {
        var i = rejectReasonRemarkList === null || rejectReasonRemarkList === void 0 ? void 0 : rejectReasonRemarkList.find(function (item) { return (item === null || item === void 0 ? void 0 : item.id) === (option === null || option === void 0 ? void 0 : option.DeclinedJobReasonId); });
        if (i)
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Typography, {
                variant: "body2"
            }, i === null || i === void 0 ? void 0 : i.Name), /*#__PURE__*/ React.createElement(Typography, {
                variant: "body2",
                color: "text.secondary"
            }, (option === null || option === void 0 ? void 0 : option.Remarks) !== "" ? option === null || option === void 0 ? void 0 : option.Remarks : "-"));
    };
    var upsertStandardJobs = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _response3, _response4, filterList, standardPartArray, standardLabourArray, finalStandardArray, payload, response;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    trackButtonClick("ButtonClickEvent", "DeclinedStandardParts_Save", undefined);
                    dispatch(showLoader({
                        isLoaderOpen: true
                    }));
                    filterList = standardJobs.filter(function (item) { return item.isSelected; });
                    standardPartArray = [];
                    standardLabourArray = [];
                    filterList.forEach(function (value) {
                        var labour = value.StandardParts.Labour;
                        var part = value.StandardParts.Part;
                        var objLabour = {};
                        var objPart = {};
                        labour.forEach(function (elem) {
                            objLabour["Quantity"] = elem.Quantity !== null ? elem.Quantity : 1;
                            objLabour["SystemName"] = "Labour";
                            objLabour["ChildId"] = elem.ChildId;
                            objLabour["StandardServiceId"] = value.StandardServiceId;
                            objLabour["ServiceGroupId"] = value.StandardServiceId;
                            objLabour["ServiceDetailType"] = 2;
                            objLabour['JobSource'] = 'PreviousDeclined';
                            standardLabourArray.push(_objectSpread({}, objLabour));
                        });
                        part.forEach(function (item) {
                            objPart["Quantity"] = item.Quantity !== null ? item.Quantity : 1;
                            objPart["SystemName"] = "Product";
                            objPart["ChildId"] = item.ChildId;
                            objPart["StandardServiceId"] = value.StandardServiceId;
                            objPart["ServiceGroupId"] = value.StandardServiceId;
                            objPart["ServiceDetailType"] = 2;
                            objPart['JobSource'] = 'PreviousDeclined';
                            standardPartArray.push(_objectSpread({}, objPart));
                        });
                    });
                    finalStandardArray = standardLabourArray.concat(standardPartArray);
                    payload = {};
                    payload = _objectSpread(_objectSpread({}, payload), {}, {
                        AdditionalJobs: finalStandardArray
                    });
                    response = {};
                    if (!(parentModuleName === EParentModuleName.ServiceEstimate)) return [3 /*break*/, 2];
                    payload = _objectSpread(_objectSpread({}, payload), {}, {
                        EstimateId: estimateId
                    });
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: upsertPreviousAdditionalJobsEstimateURL,
                            request: payload
                        }))];
                case 1:
                    response = _a.sent();
                    _a.label = 2;
                case 2:
                    if (!(parentModuleName === EParentModuleName.Appointment)) return [3 /*break*/, 4];
                    payload = _objectSpread(_objectSpread({}, payload), {}, {
                        AppointmentId: appointmentId
                    });
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: upsertPreviousAdditionalJobsAppointmentnURL,
                            request: payload
                        }))];
                case 3:
                    response = _a.sent();
                    _a.label = 4;
                case 4:
                    if (!(parentModuleName === EParentModuleName.Inspection)) return [3 /*break*/, 6];
                    payload = _objectSpread(_objectSpread({}, payload), {}, {
                        InspectionId: inspectionId
                    });
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "",
                            url: upsertPreviousAdditionalJobsInspectionURL,
                            request: payload
                        }))];
                case 5:
                    response = _a.sent();
                    _a.label = 6;
                case 6:
                    if ((_response3 = response) !== null && _response3 !== void 0 && (_response3 = _response3.payload) !== null && _response3 !== void 0 && (_response3 = _response3.value) !== null && _response3 !== void 0 && _response3.success && ((_response4 = response) === null || _response4 === void 0 || (_response4 = _response4.payload) === null || _response4 === void 0 || (_response4 = _response4.value) === null || _response4 === void 0 ? void 0 : _response4.statusCode) == 200) {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                        getSavedStandardJobs();
                        dispatch(showNotification({
                            isOpen: true,
                            message: "Standard jobs saved successfully",
                            type: "success"
                        }));
                        // buttonClickSpan.end();
                        // pageLoadSpan.end();
                        // transaction.end();
                    }
                    else {
                        dispatch(showLoader({
                            isLoaderOpen: false
                        }));
                    }
                    setDisableSaveBtn(true);
                    return [2 /*return*/];
            }
        });
    }); };
    var disableStandardJobs = function (option) {
        var _savedStandardJobs$da;
        var _find = savedStandardJobs === null || savedStandardJobs === void 0 || (_savedStandardJobs$da = savedStandardJobs.data) === null || _savedStandardJobs$da === void 0 ? void 0 : _savedStandardJobs$da.find(function (item) { return (item === null || item === void 0 ? void 0 : item.StandardServiceId) === (option === null || option === void 0 ? void 0 : option.StandardServiceId); });
        var _foundInSaved = currentlySavedStandardJobs.find(function (item) { return item.StandardServiceId === (option === null || option === void 0 ? void 0 : option.StandardServiceId); });
        if (_find !== null && _find !== void 0 && _find.StandardServiceId || _foundInSaved) {
            return true;
        }
        else {
            return false;
        }
    };
    var getServiceTypeList = function () { return __awaiter(void 0, void 0, void 0, function () {
        var _currentJobCardData$d2, _repairType$payload, _repairType$payload2, request, repairType, _repairType$payload3;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    request = {
                        ModuleEntityId: "JobCard",
                        OrganizationId: selectedBranch === null || selectedBranch === void 0 ? void 0 : selectedBranch.OrganizationId,
                        ProductId: currentJobCardData === null || currentJobCardData === void 0 || (_currentJobCardData$d2 = currentJobCardData.data) === null || _currentJobCardData$d2 === void 0 ? void 0 : _currentJobCardData$d2.ProductId
                    };
                    return [4 /*yield*/, dispatch(getListAPI({
                            key: "repairTypeList",
                            url: RepairTypeList,
                            request: request
                        }))];
                case 1:
                    repairType = _a.sent();
                    if ((repairType === null || repairType === void 0 || (_repairType$payload = repairType.payload) === null || _repairType$payload === void 0 || (_repairType$payload = _repairType$payload.value) === null || _repairType$payload === void 0 ? void 0 : _repairType$payload.statusCode) == 200 || repairType !== null && repairType !== void 0 && (_repairType$payload2 = repairType.payload) !== null && _repairType$payload2 !== void 0 && (_repairType$payload2 = _repairType$payload2.value) !== null && _repairType$payload2 !== void 0 && _repairType$payload2.success) {
                        setServiceTypeList(repairType === null || repairType === void 0 || (_repairType$payload3 = repairType.payload) === null || _repairType$payload3 === void 0 || (_repairType$payload3 = _repairType$payload3.value) === null || _repairType$payload3 === void 0 ? void 0 : _repairType$payload3.data);
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var getServiceType = function (option) {
        var i = serviceTypeList === null || serviceTypeList === void 0 ? void 0 : serviceTypeList.find(function (item) { return (item === null || item === void 0 ? void 0 : item.id) === (option === null || option === void 0 ? void 0 : option.ServiceTypeId); });
        if (i) {
            return /*#__PURE__*/ React.createElement(Typography, {
                variant: "h6"
            }, i === null || i === void 0 ? void 0 : i.DisplayName);
        }
        else {
            /*#__PURE__*/ React.createElement(Typography, {
                variant: "h6"
            }, "-");
        }
    };
    return /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        sx: {
            border: "1px solid #AFD5FF",
            borderRadius: "12px"
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        display: "flex",
        padding: 2,
        borderBottom: isOpenSection ? "1px solid #DEE4EB" : "",
        justifyContent: "space-between"
    }, /*#__PURE__*/ React.createElement(MuiStack, {
        alignItems: 'center'
    }, /*#__PURE__*/ React.createElement(Typography, {
        variant: "h5"
    }, t("Standard Jobs"), " "), /*#__PURE__*/ React.createElement(Typography, {
        sx: {
            backgroundColor: "#EEF6FF",
            padding: "3px 8px",
            borderRadius: "12px",
            border: "1px solid #AFD5FF",
            justifyContent: "center",
            color: "#3697FF",
            ml: "5px"
        },
        variant: "subtitle2"
    }, jobCount)), /*#__PURE__*/ React.createElement(MuiStack, null, isOpenSection ? /*#__PURE__*/ React.createElement("img", {
        src: ArrowUPIcon,
        onClick: function () {
            trackButtonClick("ButtonClickEvent", "StandardJobsClose", undefined);
            setIsOpenSection(!isOpenSection);
        }
    }) : /*#__PURE__*/ React.createElement("img", {
        src: ArrowDownIcon,
        onClick: function () {
            trackButtonClick("ButtonClickEvent", "StandardJobsOpen", undefined);
            setIsOpenSection(!isOpenSection);
        }
    }))), isOpenSection && (!skelaton ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            pr: 2
        }
    }, /*#__PURE__*/ React.createElement(Grid, {
        container: true,
        display: "flex"
    }, standardJobs === null || standardJobs === void 0 ? void 0 : standardJobs.map(function (option) {
        var _option$StandardParts, _option$StandardParts2, _option$StandardParts3, _option$StandardParts4, _option$StandardParts5, _option$StandardParts6, _option$StandardParts7;
        return /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            md: 6
        }, /*#__PURE__*/ React.createElement(Grid, {
            container: true
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12
        }, /*#__PURE__*/ React.createElement(ListItem, {
            sx: {
                display: "flex",
                alignItems: "center",
                paddingRight: '0px'
            }
        }, /*#__PURE__*/ React.createElement(FormControlLabel, {
            onChange: function (e) {
                onGroupChange(e, option);
            },
            disabled: disabledPreviousDeclined || disableStandardJobs(option),
            control: /*#__PURE__*/ React.createElement(Checkbox, {
                checked: (option === null || option === void 0 ? void 0 : option.isSelected) || disableStandardJobs(option)
            }),
            label: option === null || option === void 0 ? void 0 : option.StandardServiceGroupName,
            sx: {
                padding: "0px",
                fontWeight: 500,
                fontSize: "14px",
                marginRight: '0px'
            }
        }), showGroupItems && /*#__PURE__*/ React.createElement(MuiStack, null, option !== null && option !== void 0 && option.isOpen ? /*#__PURE__*/ React.createElement("img", {
            src: ArrowUPIcon,
            onClick: function () { return updateData(option, "groupItem"); }
        }) : /*#__PURE__*/ React.createElement("img", {
            src: ArrowDownIcon,
            onClick: function () { return updateData(option, "groupItem"); }
        }))), /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            sx: {
                pl: 6
            }
        }, (option === null || option === void 0 ? void 0 : option.isOpen) && (option === null || option === void 0 || (_option$StandardParts = option.StandardParts) === null || _option$StandardParts === void 0 || (_option$StandardParts = _option$StandardParts.Labour) === null || _option$StandardParts === void 0 ? void 0 : _option$StandardParts.length) > 0 && /*#__PURE__*/ React.createElement(React.Fragment, null, option === null || option === void 0 || (_option$StandardParts2 = option.StandardParts) === null || _option$StandardParts2 === void 0 ? void 0 : _option$StandardParts2.Labour.map(function (i, index) {
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sx: {
                    borderTop: "1px solid #DEE4EB"
                }
            }), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sx: {
                    backgroundColor: "#F4F7FA",
                    padding: 2,
                    borderRadius: "12px",
                    border: "1px solid #DEE4EB",
                    justifyContent: "center",
                    marginY: 1
                }
            }, /*#__PURE__*/ React.createElement(Grid, {
                container: true
            }, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sx: {
                    display: "flex",
                    justifyContent: "space-between"
                }
            }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
                sx: {
                    fontWeight: 500,
                    fontSize: "14px"
                }
            }, i === null || i === void 0 ? void 0 : i.LabourName), /*#__PURE__*/ React.createElement(Typography, {
                sx: {
                    backgroundColor: "#F4F7FA",
                    padding: "3px 8px",
                    borderRadius: "12px",
                    border: "1px solid #DEE4EB",
                    justifyContent: "center",
                    color: "#1B1D21",
                    ml: "5px"
                },
                variant: "subtitle2"
            }, "L")), /*#__PURE__*/ React.createElement(Typography, {
                sx: {
                    fontWeight: 500,
                    fontSize: "14px"
                }
            }, "\u20B9", i === null || i === void 0 ? void 0 : i.Price)), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 5
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "subtitle2",
                sx: {
                    fontWeight: 400
                },
                color: gray
            }, i === null || i === void 0 ? void 0 : i.LabourCode)), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sx: {
                    display: "flex",
                    justifyContent: "space-between"
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                color: gray,
                variant: "subtitle1"
            }, t("SERVICE_TYPE_COLUMN_NAME")), /*#__PURE__*/ React.createElement(Typography, {
                color: gray,
                variant: "subtitle1"
            }, t("Qty"), ":")), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sx: {
                    display: "flex",
                    justifyContent: "space-between"
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "h6"
            }, i === null || i === void 0 ? void 0 : i.ServiceTypeId), /*#__PURE__*/ React.createElement(Typography, {
                variant: "h6"
            }, i === null || i === void 0 ? void 0 : i.Quantity)))));
        })), (option === null || option === void 0 ? void 0 : option.isOpen) && (option === null || option === void 0 || (_option$StandardParts3 = option.StandardParts) === null || _option$StandardParts3 === void 0 || (_option$StandardParts3 = _option$StandardParts3.Part) === null || _option$StandardParts3 === void 0 ? void 0 : _option$StandardParts3.length) > 0 && /*#__PURE__*/ React.createElement(React.Fragment, null, option === null || option === void 0 || (_option$StandardParts4 = option.StandardParts) === null || _option$StandardParts4 === void 0 ? void 0 : _option$StandardParts4.Part.map(function (i, index) {
            return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sx: {
                    borderTop: "1px solid #DEE4EB"
                }
            }), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sx: {
                    backgroundColor: "#F4F7FA",
                    padding: 2,
                    borderRadius: "12px",
                    border: "1px solid #DEE4EB",
                    justifyContent: "center",
                    marginY: 1
                }
            }, /*#__PURE__*/ React.createElement(Grid, {
                container: true
            }, /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sx: {
                    display: "flex",
                    justifyContent: "space-between"
                }
            }, /*#__PURE__*/ React.createElement(MuiStack, null, /*#__PURE__*/ React.createElement(Typography, {
                sx: {
                    fontWeight: 500,
                    fontSize: "14px"
                }
            }, i === null || i === void 0 ? void 0 : i.PartName), /*#__PURE__*/ React.createElement(Typography, {
                sx: {
                    backgroundColor: "#EEF6FF",
                    padding: "3px 8px",
                    borderRadius: "12px",
                    border: "1px solid #AFD5FF",
                    justifyContent: "center",
                    color: "#3697FF",
                    ml: "5px",
                    height: "25px"
                },
                variant: "subtitle2"
            }, "P")), /*#__PURE__*/ React.createElement(Typography, {
                sx: {
                    fontWeight: 500,
                    fontSize: "14px"
                }
            }, "\u20B9", i === null || i === void 0 ? void 0 : i.Price)), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 5
            }, /*#__PURE__*/ React.createElement(Typography, {
                variant: "subtitle2",
                sx: {
                    fontWeight: 400
                },
                color: gray
            }, i === null || i === void 0 ? void 0 : i.PartCode)), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sx: {
                    display: "flex",
                    justifyContent: "space-between"
                }
            }, /*#__PURE__*/ React.createElement(Typography, {
                color: gray,
                variant: "subtitle1"
            }, t("SERVICE_TYPE_COLUMN_NAME")), /*#__PURE__*/ React.createElement(Typography, {
                color: gray,
                variant: "subtitle1"
            }, t("Qty"), ":")), /*#__PURE__*/ React.createElement(Grid, {
                item: true,
                xs: 12,
                sx: {
                    display: "flex",
                    justifyContent: "space-between"
                }
            }, getServiceType(i), /*#__PURE__*/ React.createElement(Typography, {
                variant: "h6"
            }, i === null || i === void 0 ? void 0 : i.Quantity)))));
        }))), (option === null || option === void 0 ? void 0 : option.DeclinedJobReasonId) && /*#__PURE__*/ React.createElement(Grid, {
            container: true,
            sx: {
                pl: 6
            }
        }, /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            display: "flex"
        }, /*#__PURE__*/ React.createElement(Typography, {
            variant: "subtitle2",
            color: "#0052FF"
        }, t('REASON')), option !== null && option !== void 0 && option.isResonOpen ? /*#__PURE__*/ React.createElement("img", {
            width: "10px",
            src: BlueUpIcon,
            style: {
                marginLeft: "3px"
            },
            onClick: function () { return updateData(option, "reasonItem"); }
        }) : /*#__PURE__*/ React.createElement("img", {
            src: BlueDropdownIcon,
            width: "15px",
            onClick: function () { return updateData(option, "reasonItem"); },
            style: {
                marginLeft: "1px"
            }
        })), (option === null || option === void 0 ? void 0 : option.isResonOpen) && /*#__PURE__*/ React.createElement(Grid, {
            item: true,
            xs: 12,
            sx: {
                backgroundColor: "#F4F7FA",
                padding: 2,
                borderRadius: "12px",
                border: "1px solid #DEE4EB",
                justifyContent: "center",
                marginY: 1,
                mr: 2
            }
        }, (option === null || option === void 0 || (_option$StandardParts5 = option.StandardParts) === null || _option$StandardParts5 === void 0 || (_option$StandardParts5 = _option$StandardParts5.Part) === null || _option$StandardParts5 === void 0 ? void 0 : _option$StandardParts5.length) > 0 ? getReason(option === null || option === void 0 || (_option$StandardParts6 = option.StandardParts) === null || _option$StandardParts6 === void 0 ? void 0 : _option$StandardParts6.Part[0]) : getReason(option === null || option === void 0 || (_option$StandardParts7 = option.StandardParts) === null || _option$StandardParts7 === void 0 ? void 0 : _option$StandardParts7.Labour[0]))))));
    }))), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            marginX: 2,
            paddingTop: 2,
            borderBottom: "1px solid #DEE4EB"
        }
    }), /*#__PURE__*/ React.createElement(Grid, {
        item: true,
        xs: 12,
        sx: {
            display: "flex",
            justifyContent: "end",
            padding: 2
        }
    }, /*#__PURE__*/ React.createElement(MuiLoaderButton, {
        loading: loader.isLoaderOpen,
        id: "test-ride-start-end-btn",
        variant: "contained",
        size: "medium",
        color: "primary",
        onClick: function () {
            upsertStandardJobs();
        },
        name: t("Save"),
        disabled: disabledPreviousDeclined || (standardJobs === null || standardJobs === void 0 ? void 0 : standardJobs.length) <= 0 || (standardJobs === null || standardJobs === void 0 || (_standardJobs$filter = standardJobs.filter(function (item) { return item.isSelected; })) === null || _standardJobs$filter === void 0 ? void 0 : _standardJobs$filter.length) <= 0 || disableSaveBtn
    }))) : /*#__PURE__*/ React.createElement(MuiStack, {
        style: {
            padding: '16px 16px 8px 16px',
            height: '70px'
        },
        width: "100%",
        justifyContent: "center",
        alignItems: "center"
    }, /*#__PURE__*/ React.createElement(SkeletonLoader, null))));
};
export default DeclinedStandardJobs;
